import React from "react";
import "./css/App.css";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import Layout from "./Layout";
import DeviceList2 from "./components/DeviceList2";
import DeviceList2Filtered from "./components/DeviceList2Filtered";
//import DeviceList3 from "./components/DeviceList3";
import DeviceData from "./components/DeviceData";
import DeviceDetail from "./components/DeviceDetail";
import LoginForm from "./components/LoginForm";
import Registration from "./components/Register";
import DeviceHistory from "./components/DeviceHistory";
import DeviceEvents from "./components/DeviceEvents";
import DeviceConfig from "./components/DeviceConfig";
import DevicePdu from "./components/DevicePdu";
import DeviceUpdate from "./components/DeviceUpdate";
import Admin from "./components/Admin";
import DeviceConsole from "./components/DeviceConsole";
import ResetPassword from "./components/ResetPassword";
import { AuthContext } from "./context/AuthContext";
import { canAccessAdminPanel } from "./utils/adminAccess";


function App() {
  const [showAlert, setShowAlert] = useState(false);
  const { user, isAuthInitialized } = useContext(AuthContext);
  const canViewAdminPanel = canAccessAdminPanel(user);

  useEffect(() => {
    const hasSeenAlert = localStorage.getItem("hasSeenAlert");
    if (!hasSeenAlert) {
      //setShowAlert(true); // Show the alert
    }
  }, []);

  const dismissAlert = () => {
    setShowAlert(false); // Hide the alert
    localStorage.setItem("hasSeenAlert", "true"); // Mark as seen
  };

  return (
    <Router>
      <Layout>
        <div className="App">
        {showAlert && (
      <div className="apology-banner">
        We apologize for the server downtime over the weekend. We're addressing the issue to ensure it doesn't happen again. Thank you for your understanding!
        <button className="dismiss-button" onClick={dismissAlert}>
          Dismiss
        </button>
      </div>
    )}
          <Routes>
            <Route path="/" element={<DeviceList2 />} /> {/* Home Page */}
            <Route path="/filter" element={<DeviceList2Filtered />} /> {/* Filtered List Page */}
            <Route
              path="/admin"
              element={
                !isAuthInitialized ? (
                  <div className="spinner-container"><div className="spinner"></div></div>
                ) : canViewAdminPanel ? (
                  <Admin />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
            <Route path="/login" element={<LoginForm />} /> {/* Login Page */}
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/device/history" element={<DeviceHistory />} />{" "}
            <Route path="/device/data" element={<DeviceData />} />{" "}
            <Route path="/device/detail" element={<DeviceDetail />} />{" "}
            <Route path="/device/events" element={<DeviceEvents />} />{" "}
            <Route path="/device/console" element={<DeviceConsole />} />{" "}
            <Route path="/device/config" element={<DeviceConfig />} />{" "}
            <Route path="/device/pdu" element={<DevicePdu />} />{" "}
            <Route path="/device/update" element={<DeviceUpdate />} />{" "}
          </Routes>
        </div>
      </Layout>
    </Router>
  );
}

export default App;
